module.exports = "https://r.zoocdn.com/_next/static/images/house-on-hill-beaf923425dbb1aa4e96d0dfc19189c4.svg";